import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Dropzone from 'react-dropzone';
import S3 from 'react-aws-s3';
import { useJsApiLoader } from '@react-google-maps/api';
import PlacesAutocomplete, { geocodeByPlaceId } from 'react-places-autocomplete';
import { nextStep, previousStep, setBusinessInfo } from 'src/slices/signup';
import GoogleMapReact from 'google-map-react';
import NumberFormat from 'react-number-format';
import { setCurrentMarker } from 'src/slices/location';
import { updateBusinessInfo } from 'src/slices/info';
import dayjs from 'dayjs';
import MapMarker from 'src/components/atoms/MapMarker';
import Select from 'react-select';
import Button from 'src/components/atoms/Button';
import InputWrap from 'src/components/molecules/InputWrap';
import css from './StoreInformation.module.scss';
import css2 from './shared.module.scss';

export default function StoreInformation({ isSignupMount }) {
  const dispatch = useDispatch();
  const { user, token, businessInfo, isFirst } = useSelector((state) => state.signup);
  const { coords } = useSelector((state) => state.location);
  const selectedBusiness = useSelector((state) => state.location.selectedMarker);

  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  const categories = [
    {
      value: 'restaurant',
      label: 'Restaurant',
    },
    {
      value: 'grocery',
      label: 'Grocery',
    },
    {
      value: 'cafe',
      label: 'Cafe',
    },
    ,
    {
      value: 'bakery',
      label: 'Bakery',
    },
  ];

  const map = {
    center: { lat: coords.lat, lng: coords.long },
    zoom: 3,
  };

  let createMapOptions = {
    styles: [
      {
        featureType: 'poi', // turn of places markes
        stylers: [{ visibility: 'off' }],
      },
      {
        stylers: [{ saturation: 0 }],
      },
    ],
  };
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyBNeBOF4IceCyACowwiMUKi6ZUy_OeyqZU',
    libraries: ['places'],
  });

  /*
	Parse place results
	*/
  const [isMount, setIsMount] = useState(true);
  useEffect(() => {
    /*
		Parse Address
		*/

    // IMPORTANT: Do not remove
    // prettier-ignore
    if (
			(selectedBusiness?.formatted_address &&
				selectedBusiness.geometry?.location?.lat() != businessInfo.coords?.lat &&
				selectedBusiness.geometry?.location?.lng() != businessInfo.coords?.long) ||
				// prettier-ignore
			(!isMount || (isSignupMount && !isFirst) &&
				selectedBusiness.geometry?.location?.lat() == businessInfo.coords?.lat &&
				selectedBusiness.geometry?.location?.lng() == businessInfo.coords?.long)
		) {
			setIsMount(false)
			let category = ''
			if (selectedBusiness.types.includes('supermarket')) {
				category = 'grocery'
			}

			if (selectedBusiness.types.includes('restaurant')) {
				category = 'restaurant'
			}

			/*
			Parse hours
			*/

			let hours = []
			let isHoursAccurate = true

			const days = [
				'Monday',
				'Tuesday',
				'Wednesday',
				'Thursday',
				'Friday',
				'Saturday',
				'Sunday',
			]
			try {
				if (
					selectedBusiness.opening_hours &&
					selectedBusiness?.opening_hours?.periods?.length <= 7 &&
					selectedBusiness?.opening_hours?.periods?.length > 1
				) {
					hours = selectedBusiness?.opening_hours?.periods?.map(period => {
						return {
							day: days[period.open.day == 0 ? 6 : period.open.day - 1],
							openTime: dayjs()
								.hour(period.open.hours)
								.minute(period.open.minutes)
								.format('hh:mm A'),
							closeTime: dayjs()
								.hour(period.close?.hours)
								.minute(period.close?.minutes)
								.format('hh:mm A'),
							isClosed: false,
						}
					})

					// Fill in closed days
					if (hours.length != 7) {
						const daysFound = hours.map(dayObj => dayObj.day)

						const missingDays = days.filter(day => !daysFound.includes(day))


						missingDays.forEach(day => {
							hours.splice(days.indexOf(day), 0, {
								day: day,
								openTime: '',
								closeTime: '',
								isClosed: true,
							})
						})
					}
				} else {
					hours = days.map((day, index) => {
						return {
							day: day,
							openTime: '12:00 AM',
							closeTime: '11:59 PM',
							isClosed: false,
						}
					})
					isHoursAccurate = false
				}
			} catch {
				hours = days.map((day, index) => {
					return {
						day: day,
						openTime: '12:00 AM',
						closeTime: '11:59 PM',
						isClosed: false,
					}
				})
				isHoursAccurate = false
			}

			dispatch(
				setBusinessInfo({
					bizName:
						selectedBusiness.name +
						(selectedBusiness.firstLine ? ` (${selectedBusiness.firstLine})` : ''), // + firstLine ? `(${firstLine})` : '',
					bizCategory: category,
					bizDesc: '',
					bizDesc: '',
					address: selectedBusiness.formatted_address,
					neighborhood: selectedBusiness.neighborhood || selectedBusiness.city,
					phones: [selectedBusiness.formatted_phone_number],
          notifPhone: selectedBusiness.notifPhone,
					// logo: '',
					coords: {
						lat: selectedBusiness.geometry?.location?.lat(),
						long: selectedBusiness.geometry?.location?.lng(),
					},
					hours,

					isHoursAccurate,
				})
			)
		}
  }, [selectedBusiness]);

  /*

	Place autocomplete search

	*/
  const request = {
    fields: [
      'name',
      // 'rating',
      'formatted_phone_number',
      'formatted_address',
      'geometry',
      'opening_hours',
      // 'business_status',
      'type',
      'vicinity',
      'photos',
      'address_components',
    ],

    types: [
      'restaurant',
      'supermarket',
      'cafe',
      'bakery',
      'meal_delivery',
      'meal_takeaway',
      'restaurant',
    ],
  };

  const autoCompleteName = async (address, placeId) => {
    let details;

    if (isLoaded) {
      const mapElement = new window.google.maps.Map(document.getElementById('map'), {
        center: { lat: coords.lat, lng: coords.long },
        zoom: 15,
      });

      const service = new window.google.maps.places.PlacesService(mapElement);

      if (service) {
        service.getDetails({ placeId, fields: request.fields }, (place, status) => {
          if (status == window.google.maps.places.PlacesServiceStatus.OK) {
            setSuggestions([]);
            setSuggestionsLimit(5);
            dispatch(
              setCurrentMarker({
                ...place,
                photos: place?.photos?.map((photo) => photo.getUrl()),
              }),
            );
          } else {
            toast.error(
              'An error occurred while fetching the store information, please try again.',
            );
          }
        });
      }
      return details;
    }
  };

  const autoCompleteAddress = async (address, placeId) => {
    let details;

    const [res] = await geocodeByPlaceId(placeId);
    if (isLoaded) {
      const mapElement = new window.google.maps.Map(document.getElementById('map'), {
        center: { lat: coords.lat, lng: coords.long },
        zoom: 15,
      });

      const service = new window.google.maps.places.PlacesService(mapElement);

      if (service) {
        service.nearbySearch(
          {
            location: res.geometry.location,
            rankBy: window.google.maps.places.RankBy.PROMINENCE,
            radius: 150,
            // fields: ['place_id'],
            type: ['establishment'],
          },
          (places, status) => {
            if (status == window.google.maps.places.PlacesServiceStatus.OK) {
              setSuggestions(
                places
                  .filter((place) => place.types.includes('establishment'))
                  .map((place) => ({
                    place,

                    place_id: place.place_id,
                    formattedSuggestion: {
                      active: false,
                      mainText: place.name,
                      secondaryText: place.vicinity,
                    },
                  })),
              );
              setShowModal(true);
            } else {
              toast.warning(`We couldn't find a store at this address please try a different one.`);
            }
          },
        );
      }
      return details;
    }
  };

  /*
	Image uploading 
	*/

  // Change these
  const config = {
    bucketName: 'carty-app',
    region: 'us-east-1',
    accessKeyId: 'AKIAQHLGGFVPLOMRLX5O',
    secretAccessKey: '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',
    s3Url: 'https://carty-app.s3.amazonaws.com' /* optional */,
  };
  const ReactS3Client = new S3(config);

  const handleImageDrop = (acceptedFiles) => {
    if (!['image/jpeg', 'image/png'].includes(acceptedFiles[0]?.type)) {
      toast.warning('Only .png and .jpg files are accepted');
      return;
    }
    // toast.loading('Uploading...')
    ReactS3Client.uploadFile(acceptedFiles[0]).then((image) => {
      // toast.dismiss()
      dispatch(setBusinessInfo({ logo: image.location }));

      dispatch(
        updateBusinessInfo({
          data: {
            businessLogo: image.location,
          },
          fieldset: 'media',

          signupToken: token,
          merchantId: user.id,
        }),
      );
    });
  };

  /*
	Input Validation/Dispatching Request
	*/

  const validator = () => {
    if (!businessInfo.bizName) {
      toast.warning(`"Store Name" is a required field`);
      return null;
    } else if (!businessInfo.bizCategory) {
      toast.warning(`"Store Category" is a required field`);
      return null;
    } else if (!businessInfo.bizDesc) {
      toast.warning(`"Store Description" is a required field`);
      return null;
    } else if (!businessInfo.logo) {
      toast.warning(`"Store Logo" is required`);
      return null;
    } else {
      return businessInfo;
    }
  };
  const handleBack = () => {
    dispatch(previousStep());
  };
  const handleNext = () => {
    const data = {
      businessName: businessInfo.bizName,
      businessDescription: businessInfo.bizDesc,
      businessCategory: businessInfo.bizCategory,
      address: businessInfo.address,
      coordinates: JSON.stringify([businessInfo.coords.long, businessInfo.coords.lat]),
      prepTime: 15,
      phones: JSON.stringify([businessInfo.phone]),
      neighborhood: businessInfo.neighborhood,
    };
    if (validator(businessInfo)) {
      dispatch(
        updateBusinessInfo({
          data,
          fieldset: 'business',
          signupToken: token,
          merchantId: user.id,
        }),
      )
        .unwrap()
        .then(() => dispatch(nextStep()));
    }
  };

  /*
	Event Handlers
	*/
  const handleSelect = async (address, placeId, suggestion) => {
    autoCompleteName(address, true);
  };

  /*
	Styling	
	*/

  const customStyles = {
    multiValue: (styles) => {
      return {
        ...styles,
        backgroundColor: 'rgba(0,0,0,0.5)',
        borderRadius: '8px',
        padding: '4px',
      };
    },
    multiValueRemove: (styles) => ({
      ...styles,
      ':hover': {
        backgroundColor: 'rgba(0,0,0,0.5)',
      },
    }),

    option: (base) => ({
      ...base,
      backgroundColor: 'transparent',
    }),
  };
  const [suggestionsLimit, setSuggestionsLimit] = useState(5);

  const handleClick = async (place_id) => {
    if (isLoaded) {
      const mapElement = new window.google.maps.Map(document.getElementById('map'), {
        center: { lat: coords.lat, lng: coords.long },
        zoom: 15,
      });

      const service = new window.google.maps.places.PlacesService(mapElement);
      service.getDetails({ placeId: place_id, fields: request.fields }, (place, status) => {
        if (status == window.google.maps.places.PlacesServiceStatus.OK) {
          dispatch(
            setCurrentMarker({
              ...place,
              photos: place?.photos?.map((photo) => photo.getUrl()),
            }),
          );
          setSuggestions([]);
          setSuggestionsLimit(5);
        } else {
          toast.error('An error occurred while fetching the store information, please try again.');
        }
      });
    }
  };

  return (
    <>
      <div id="map"></div>
      <Dropzone
        accept={['image/jpeg', 'image/png']}
        onDrop={(acceptedFiles) => handleImageDrop(acceptedFiles)}
      >
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps()} className={css2['box']}>
            <input {...getInputProps()} />
            <div
              className={`
                            ${businessInfo.logo ? '' : css2['image-upload-box']} 
                            `}
            >
              {loading ? (
                <p>uploading</p>
              ) : businessInfo.logo ? (
                <img src={businessInfo.logo} className={css2['uploaded-image']} />
              ) : (
                <i className="fad fa-camera" />
              )}
            </div>
            <span>Store Logo</span>
          </div>
        )}
      </Dropzone>
      <InputWrap
        label="Store Name"
        component={
          <PlacesAutocomplete
            value={businessInfo?.bizName}
            onChange={(value) => dispatch(setBusinessInfo({ bizName: value }))}
            onSelect={(address, placeId) => autoCompleteName(address, placeId)}
            searchOptions={{
              types: ['establishment'],
              componentRestrictions: { country: 'us' },
            }}
            debounce={150}
          >
            {({ getInputProps, suggestions: nameSuggestions, getSuggestionItemProps, loading }) => (
              <div>
                <input
                  className={css['rpa-input']}
                  {...getInputProps()}
                  autoComplete="chrome-off"
                />

                {nameSuggestions.length != 0 && (
                  <div className={css['rpa-menu']}>
                    {/* {loading ? <div>Loading...</div> : null} */}
                    {nameSuggestions.map((suggestion) => {
                      return (
                        <div className={css['suggestion']} {...getSuggestionItemProps(suggestion)}>
                          <p className={css['main-text']}>
                            {suggestion.formattedSuggestion?.mainText}
                          </p>
                          <p className={css['address-text']}>
                            <i className="fad fa-map-marker-alt" />{' '}
                            {suggestion.formattedSuggestion?.secondaryText}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                )}

                {nameSuggestions.length == 0 && suggestions.length != 0 && (
                  <div className={css['rpa-menu']}>
                    {/* {loading ? <div>Loading...</div> : null} */}
                    {suggestions.map((suggestion, index) => {
                      return (
                        index < suggestionsLimit && (
                          <div
                            className={css['suggestion']}
                            onClick={() => handleClick(suggestion.place_id)}
                          >
                            <p className={css['main-text']}>
                              {suggestion.formattedSuggestion?.mainText}
                            </p>
                            <p className={css['address-text']}>
                              <i className="fad fa-map-marker-alt" />{' '}
                              {suggestion.formattedSuggestion?.secondaryText}
                            </p>
                          </div>
                        )
                      );
                    })}

                    {suggestions.length - suggestionsLimit > 0 ? (
                      <div
                        className={css['suggestion']}
                        onClick={() => setSuggestionsLimit(suggestionsLimit + 5)}
                      >
                        <p className={css['main-text']}>
                          ...and {suggestions.length - suggestionsLimit} more
                        </p>
                      </div>
                    ) : (
                      <div
                        className={css['suggestion']}
                        onClick={() => {
                          setSuggestions([]);
                          setSuggestionsLimit(5);
                        }}
                        style={{
                          // backgroundColor: 'rgba(0,0,0,0.3)',
                          color: 'white',
                          fontFamily: 'inherit',
                        }}
                      >
                        <p className={css['main-text']}>Clear Suggestions</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </PlacesAutocomplete>
        }
      />
      <div
        style={{
          height: '240px',
          borderRadius: '16px',
          marginBottom: 25,
          overflow: 'hidden',
        }}
      >
        <GoogleMapReact
          options={createMapOptions}
          bootstrapURLKeys={{
            key: 'AIzaSyBNeBOF4IceCyACowwiMUKi6ZUy_OeyqZU',
          }}
          center={
            (businessInfo.coords.lat && {
              lat: businessInfo.coords.lat,
              lng: businessInfo.coords.long,
            }) ||
            map.center
          }
          zoom={(businessInfo.coords.lat && 15) || map.zoom}
          yesIWantToUseGoogleMapApiInternals
          // onClick={setMarker}
        >
          {businessInfo.coords.lat && businessInfo.coords.long ? (
            <MapMarker
              label={businessInfo.bizName}
              lat={businessInfo.coords.lat}
              lng={businessInfo.coords.long}
            />
          ) : null}
        </GoogleMapReact>
      </div>

      <InputWrap
        label="Address"
        component={
          <PlacesAutocomplete
            value={businessInfo.address}
            onChange={(value) => dispatch(setBusinessInfo({ address: value }))}
            onSelect={(address, placeId) => autoCompleteAddress(address, placeId)}
          >
            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
              <div>
                <input
                  // className={css["modal__bottom__textarea"]}
                  className={css['rpa-input']}
                  {...getInputProps()}
                  // placeholder="Address"
                  autoComplete="chrome-off"
                />

                {suggestions.length != 0 && (
                  <div
                    className={css['rpa-menu']}
                    // className={
                    //     suggestions.length === 0
                    //         ? "suggestion__div2"
                    //         : "suggestion__div"
                    // }
                  >
                    {suggestions.map((suggestion) => {
                      const style = {
                        backgroundColor: suggestion.active
                          ? 'rgba(255,255,255,0.2)'
                          : 'rgba(0,0,0,0.3)',
                        color: 'white',
                        // color: suggestions.active
                        //     ? "#ffffff"
                        //     : "",
                        fontFamily: 'inherit',
                      };
                      return (
                        <div className={css['suggestion']} {...getSuggestionItemProps(suggestion)}>
                          <p className={css['main-text']}>
                            {suggestion.formattedSuggestion.mainText}
                          </p>
                          <p className={css['address-text']}>
                            <i className="fad fa-map-marker-alt" />{' '}
                            {suggestion.formattedSuggestion.secondaryText}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
          </PlacesAutocomplete>
        }
      />

      {/* <InputWrap
				label='Store Name'
				component={
					<input
						value={businessInfo?.bizName}
						onChange={e => dispatch(setBusinessInfo({ bizName: e.target.value }))}
					/>
				}
			/> */}

      <InputWrap
        label="Neighborhood"
        component={
          <input
            value={
              businessInfo.neighborhood
              // selectedBusiness?.address_components?.find(address =>
              // 	address.types.includes('sublocality')
              // )?.long_name
            }
            onChange={(e) =>
              dispatch(
                setBusinessInfo({
                  neighborhood: e.target.value,
                }),
              )
            }
          />
        }
      />
      <InputWrap
        label="Phone"
        component={
          <NumberFormat
            allowEmptyFormatting
            mask="_"
            format="+1 (###) ###-####"
            type="tel"
            value={businessInfo.phone}
            onChange={(e) =>
              dispatch(
                setBusinessInfo({
                  phone: e.target.value,
                }),
              )
            }
          />
        }
      />
      <InputWrap
        label="Notification Phone (Optional)"
        helpText="Enter a number if you want to separate Livecart notifications from customer calls."
        component={
          <NumberFormat
            allowEmptyFormatting
            mask="_"
            format="+1 (###) ###-####"
            type="tel"
            value={businessInfo.notifPhone}
            onChange={(e) =>
              dispatch(
                setBusinessInfo({
                  notifPhone: e.target.value,
                }),
              )
            }
          />
        }
      />
      <InputWrap
        label="Category"
        component={
          <Select
            options={categories}
            className={css.select}
            onChange={(option) => dispatch(setBusinessInfo({ bizCategory: option.value }))}
            value={
              businessInfo?.bizCategory
                ? categories.find((option) => option?.value == businessInfo.bizCategory)
                : null
            }
            styles={customStyles}
          />
        }
      />
      {/* {businessInfo?.bizCategory == 'restaurant' && (
				<InputWrap
					label='Cuisines'
					component={
						<Select
							styles={customStyles}
							options={cuisines}
							className={css.select}
							onChange={setCuisine}
							value={cuisine}
							isMulti={true}
						/>
					}
				/>
			)} */}
      <InputWrap
        label="Description"
        component={
          <textarea
            onChange={(e) =>
              dispatch(
                setBusinessInfo({
                  bizDesc: e.target.value,
                }),
              )
            }
            value={businessInfo.bizDesc}
          />
        }
      />

      <div className={css2['buttons']}>
        {
          <Button
            label="Back"
            variant="tertiary"
            color="white"
            iconLeft="fa fa-chevron-left"
            action={handleBack}
          />
        }
        <Button
          label="Continue"
          variant="primary"
          color="white"
          iconRight="fa fa-chevron-right"
          action={handleNext}
        />
      </div>
      {/* {showModal &&
				suggestions.length != 0 &&
				toast(
					<div
					// className={css['rpa-menu']}
					// className={
					//     suggestions.length === 0
					//         ? "suggestion__div2"
					//         : "suggestion__div"
					// }
					>
						{suggestions.map(suggestion => {
							const style = {
								backgroundColor: 'purple',
								color: 'white',
								// color: suggestions.active
								//     ? "#ffffff"
								//     : "",
								fontFamily: 'inherit',
							}
							return (
								<div className={css['suggestion']} style={style}>
									<p className={css['main-text']}>{suggestion.name}</p>
									<p className={css['address-text']}>
										<i className='fad fa-map-marker-alt' />{' '}
										{suggestion.vicinity}
									</p>
								</div>
							)
						})}
					</div>,
					{ autoClose: false }
				)} */}
    </>
  );
}
